// Vendor
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';
import 'bootstrap-sass/assets/javascripts/bootstrap/popover';

// JS imports
import Promise from 'promise-polyfill';
import urlPolyfill from 'url-polyfill';
import ModuleManager from './ModuleManager';
import moduleConfig from './config';
import startModules from '../modules/modules';
import './SearchFilter';

// Promise polyfill
if (! window.Promise) {
  window.Promise = Promise;
}

if (! window.URL) {
  window.URL = urlPolyfill;
}

// Call polyfill to fit in images
const objectFitImages = require('object-fit-images');

document.addEventListener('DOMContentLoaded', () => {
  objectFitImages();
});

// Initialize Hachette global var
window.hachette = hachette;

// Add module manager to global var, making it a "singleton"
window.hachette.manager = new ModuleManager(moduleConfig, window.hachette);

// Initialize global modules
document.addEventListener('DOMContentLoaded', () => startModules());

// header search form
const activeSearchClass = 'site-search__form--active';
const siteHeader = document.querySelector('#site-header');

if (siteHeader) {
  const globalSearch = siteHeader.querySelector('#global-hbg-search');
  const globalSearchInput = siteHeader.querySelector('.site-search__input');
  if (globalSearch) {
    globalSearch.addEventListener('submit', (e) => {
      if (! siteHeader.classList.contains(activeSearchClass)) {
        e.preventDefault(); // stop form from submitting
        siteHeader.classList.add(activeSearchClass);
      } else if (
        '' === globalSearchInput.value
          && siteHeader.classList.contains(activeSearchClass)
      ) {
        e.preventDefault(); // stop form from submitting
        siteHeader.classList.remove(activeSearchClass); // close searchform
      }
    });
  }
}

const siteContent = document.querySelector('#content');

if (siteContent) {
  const inPageSearch = siteContent.querySelector('#global-hbg-search');
  const inPageSearchInput = siteContent.querySelector('.site-search__input');
  if (inPageSearch) {
    inPageSearch.addEventListener('submit', (e) => {
      if ('' === inPageSearchInput.value) {
        e.preventDefault(); // prevent in page search from navigating if empty
      }
    });
  }
}

if (module.hot) {
  module.hot.accept();
  startModules();
}

// hover intent for main nav
const activeNavClass = 'site-header__sub-menu--active';
const desktopArrowClass = 'site-header__sub-menu--active-arrow';

// if the person tabs into a menu, then clicks somewhere on the page out of it
let activeSubMenu = '';
document.addEventListener('click', (e) => {
  if (activeSubMenu instanceof HTMLElement) {
    const isClickInside = activeSubMenu.contains(e.target);

    if (! isClickInside) {
      activeSubMenu.classList.remove(activeNavClass);
      activeSubMenu.parentElement.classList.remove(desktopArrowClass); // eslint-disable-line max-len
      activeSubMenu = '';
    }
  }
  // else if ('undefined' !== typeof e.target.classList && e.target.classList.contains('site-header__hamburger') && ! e.target.classList.contains('site-header__mobile-menu--active')) { // eslint-disable-line max-len
  //   document.querySelector('.site-header__menu a').focus();
  // } else if (e.target.classList.contains('site-header__hamburger') && e.target.classList.contains('site-header__mobile-menu--active')) { // eslint-disable-line max-len
  //   document.querySelector('.site-header__mobile-logo a').focus();
  // }
});

// if the person presses the escape key with a menu open, close it
document.addEventListener('keyup', (e) => {
  if ('Escape' === e.key && activeSubMenu instanceof HTMLElement) {
    activeSubMenu.classList.remove(activeNavClass);
    activeSubMenu.parentElement.classList.remove(desktopArrowClass); // eslint-disable-line max-len
    activeSubMenu = '';
  } else if ('Escape' === e.key && document.getElementById('menu-hachette-primary-menu').classList.contains('site-header__mobile-menu--active')) { // eslint-disable-line max-len
    document.getElementById('menu-hachette-primary-menu').classList.remove('site-header__mobile-menu--active'); // eslint-disable-line max-len
    document.querySelector('.site-header__mobile-logo a').focus();
  }
});

document.addEventListener('keyup', (e) => {
  if ('ArrowDown' === e.key && activeSubMenu instanceof HTMLElement) {
    document.querySelector('.ui-menu-item a').focus();
  }
});

// eslint-disable-next-line max-len
const topLevelNavItems = document.querySelectorAll('.site-header__nav > ul > .site-header__menu-item-has-children');
Array.prototype.forEach.call(topLevelNavItems, (navItem) => {
  const subMenu = navItem.querySelector('.site-header__sub-menu');
  const subMenuId = subMenu.dataset.toggleElement;
  const expand = navItem.querySelector('.site-header__menu-expand');
  const expandId = `expand-${expand.dataset.toggleElement}`;

  // tab browsing means we need to show and hide on focus in and out
  navItem.querySelector('.site-header__menu-item-text').querySelector('a').addEventListener('focusin', (e) => { // eslint-disable-line max-len
    activeSubMenu = document.getElementById(subMenuId);
    document.getElementById(subMenuId).classList.add(activeNavClass);
    e.target.parentElement.parentElement.classList.add(desktopArrowClass);
    const menuItems = document.getElementById(subMenuId).querySelectorAll('.site-header__menu-item-text a'); // eslint-disable-line max-len
    // if it's the last item tabbed out of the dropdown menu, hide the dropdown
    menuItems[menuItems.length - 1].addEventListener('focusout', () => {
      document.getElementById(subMenuId).classList.remove(activeNavClass);
      document.getElementById(subMenuId).parentElement.classList.remove(desktopArrowClass); // eslint-disable-line max-len
    });
  });

  // if back-tabbing between header items, hide the dropdown between back tabs
  navItem.querySelector('.site-header__menu-item-text').querySelector('a').addEventListener('focusout', (e) => { // eslint-disable-line max-len
    if ((null !== e.relatedTarget && e.relatedTarget.parentElement.parentElement.classList.contains('site-header__menu-item-has-children') // eslint-disable-line max-len
      && e.target.parentElement.parentElement.classList.contains('site-header__menu-item-has-children') // eslint-disable-line max-len
      && e.target.parentElement.parentElement.parentElement.classList.contains('site-header__menu') // eslint-disable-line max-len
      && e.relatedTarget.parentElement.parentElement.parentElement.classList.contains('site-header__menu') // eslint-disable-line max-len
    )
    || (null !== e.relatedTarget && e.relatedTarget.parentElement.parentElement.classList.contains('site-header__social'))) { // eslint-disable-line max-len
      document.getElementById(subMenuId).classList.remove(activeNavClass);
      document.getElementById(subMenuId).parentElement.classList.remove(desktopArrowClass); // eslint-disable-line max-len
    }
  });

  // if there is no expand option use hover intent
  if ('none' === $(`#${expandId}`).css('display')) {
    $(`#${subMenuId}`).parent().hoverIntent({
      over() {
        $(`#${subMenuId}`).addClass(activeNavClass);
        $(this).addClass(desktopArrowClass);
      },
      out() {
        $(`#${subMenuId}`).removeClass(activeNavClass);
        $(this).removeClass(desktopArrowClass);
      },
    });
  }
});

// hover intent for global nav drop downs
const activeImprintNavClass = 'site-header__sub-menu--active-imprint';
// eslint-disable-next-line max-len
const topLevelImprintNavItems = document.querySelectorAll('.menu-imprint-nav-container > ul > .site-header__menu-item-has-children');
// eslint-disable-next-line max-len
const notImprintNav = document.querySelectorAll('.site-header__nav > ul > .site-header__menu-item-has-children');
const searchBtn = document.querySelectorAll('.site-search__button');
Array.prototype.forEach.call(topLevelImprintNavItems, (navImprintItem) => {
  const subImprintMenu = navImprintItem.querySelector('.site-header__sub-menu');
  const subImprintMenuId = subImprintMenu.dataset.toggleElement;

  // $(`#${subImprintMenuId}`).parent().on('focusin', () => {
  //   $(`#${subImprintMenuId}`).addClass(activeImprintNavClass);
  //   $(notImprintNav).css('zIndex', '0');
  //   $(searchBtn).css('zIndex', '0');
  // });
  // $(`#${subImprintMenuId}`).parent().on('focusout', () => {
  //   $(`#${subImprintMenuId}`).removeClass(activeImprintNavClass);
  //   $(notImprintNav).css('zIndex', '50');
  //   $(searchBtn).css('zIndex', '100');
  // });
  $(`#${subImprintMenuId}`).parent().hoverIntent({
    over() {
      $(`#${subImprintMenuId}`).addClass(activeImprintNavClass);
      $(notImprintNav).css('zIndex', '0');
      $(searchBtn).css('zIndex', '0');
    },
    out() {
      $(`#${subImprintMenuId}`).removeClass(activeImprintNavClass);
      $(notImprintNav).css('zIndex', '50');
      $(searchBtn).css('zIndex', '100');
    },
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const lazyLoadableTitles = document.querySelectorAll('.lazy-load-isbn');

  // Collect necessary info for all the titles on the page to be lazy-loaded.
  const toLoad = Array.prototype.reduce.call(
    lazyLoadableTitles,
    (rest, isbnEl) => {
      const { isbn, size: imageSize } = isbnEl.dataset;
      return isbn && imageSize
        ? [
          ...rest,
          { isbn, isbnEl, imageSize },
        ]
        : rest;
    },
    [],
  );

  /**
   * Run a batch request of lazy-loaded titles.
   *
   * @param {array} isbnsData ISBN data.
   */
  const runBatch = (isbnsData) => {
    const isbnParam = isbnsData.map((data) => `${data.isbn}:${data.imageSize}`);
    fetch(
      `${window.lazyTitles.ajaxUrl}&isbn=${isbnParam.join(',')}`,
      {
        credentials: 'same-origin',
      },
    )
      .then((response) => response.json())
      .then((json) => {
        if (! json.success || ! json.data) {
          return;
        }

        Array.prototype.forEach.call(json.data, (title) => {
          const target = isbnsData.filter(
            ({ isbn, imageSize }) => isbn === title.isbn
              && imageSize === title.image_size,
          ).shift();
          if (target.isbnEl) {
            // Trigger custom event and handle edge case for IE11.
            let event;
            try {
              event = new CustomEvent('isbnLoaded', { detail: title });
            } catch (e) {
              event = document.createEvent('CustomEvent');
              event.initCustomEvent('isbnLoaded', true, true, title);
            }
            target.isbnEl.dispatchEvent(event);
          }
        });
      });
  };

  // Chunk the loadable titles into batches of 5 and dispatch the requests.
  for (let i = 0; i < toLoad.length; i += 5) {
    runBatch(toLoad.slice(i, i + 5));
  }
});
